/* eslint-disable import/prefer-default-export */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import ModalEmailVerificationMessage from 'Screens/Contextualization/Settings/components/Account/components/ModalEmailVerificationMessage';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';
import { MODAL_EMAIL_VERIFICATION_MESSAGE, MODAL_SET_REPORT_TEMPLATE_NAME } from 'store/modals/modals';

export const MODALS = [
  { component: <ModalEmailVerificationMessage />, id: MODAL_EMAIL_VERIFICATION_MESSAGE },
  { component: <EEFeatureSlot featureKey="report-template-name-modal" />, id: MODAL_SET_REPORT_TEMPLATE_NAME }
];
